import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

interface DeleteSlotConfirmDialogProps {
  open: boolean;
  isDeleting: boolean;
  confirmDisabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteSlotConfirmDialog = ({ open, isDeleting, confirmDisabled = false, onCancel, onConfirm }: DeleteSlotConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={isDeleting ? undefined : onCancel} maxWidth="sm" fullWidth>
      <DialogTitle variant="dialogTitle" align="center">
        <Trans i18nKey="deleteSlotConfirmDialog.title">Delete Program</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3, px: 3 }}>
        <Typography variant="body1" component="p">
          <Trans i18nKey="deleteSlotConfirmDialog.body">Are you sure you want to delete this program off of your Swerve Drive robot?</Trans>
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'center', px: 2, py: 2 }}>
        <Stack direction="row" spacing={2}>
          <Button variant="text" onClick={onCancel} disabled={isDeleting}>
            <Trans i18nKey="deleteSlotConfirmDialog.cancel">Cancel</Trans>
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm} disabled={isDeleting || confirmDisabled}>
            <Trans i18nKey="deleteSlotConfirmDialog.delete">Delete</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSlotConfirmDialog;
